<template>
	<div class="row" v-if="municipe">
		<div class="col-md-6 col-md-offset-3">
			<v-form-cadastro-municipe :municipe="municipe"></v-form-cadastro-municipe>
		</div>
	</div>
</template>

<script>
	import VFormCadastroMunicipe from './form';
	import Municipe from 'models/municipe';

	export default {
		components: { VFormCadastroMunicipe },

		data() {
			return {
				municipe: ''
			};
		},

		async created() {
			try {
				let municipe = await Municipe.getCurrent();

				if (municipe) {
					this.municipe = municipe;
				}
			} catch(e) {
				this.$router.push('/agendas');
			}
		}
	};
</script>


// WEBPACK FOOTER //
// cadastro.vue?48e6de94